import { mainStore } from "../stores/MainStore";

export const useChatStore = () => {
  return mainStore.chatStore;
};
